import App from '@/AppHomeowner'
import router from '@/router/homeowner'
import store from '@/store'
import init from '@/init'

const APP_ID = 'homeowner'

init(APP_ID, App, router, store)
